import type { Graph } from "@lr-notitia/notitia-engineer/schemas";
import { useGraphStore } from "./graph";

let graphStore: ReturnType<typeof useGraphStore>;
function init() {
	graphStore = useGraphStore();
}

export type Recording = {
	id: string;
	start: number;
	domainId: string;
	access: Map<string, number>;
	graph: Graph;
};

export let latestRecordingId = "";
const recordings: Recording[] = [];

export async function createRecording(domainId: string): Promise<string> {
	return Promise.resolve(""); // RECORIDNG DISABLED
	init();
	const start = Date.now();
	const access = new Map<string, number>();
	const graph = graphStore.graph;
	const recording: Recording = {
		id: Math.random().toString(36).substr(2, 9),
		start,
		domainId,
		access,
		graph,
	};
	recordings.push(recording);
	if (process.env.NODE_ENV !== "production") return new Promise((resolve) => resolve(recording.id));
	return new Promise((resolve) => {
		fetch("/api/metrics/recordings", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				domainId,
				start,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				recording.id = data.id;
				latestRecordingId = data.id;
				resolve(data.id);
			});
	});
}

// let timeout: ReturnType<typeof setTimeout>;
export function recordAccess(nodeId: string) {
	return; // RECORIDNG DISABLED
	// init();
	// const recording = recordings.find((r) => r.id === latestRecordingId);
	// if (!recording) return;
	// const alreadyAccessed = recording.access.get(nodeId);
	// if (alreadyAccessed) return;
	// const now = Date.now();
	// const delta = now - recording.start;
	// recording.access.set(nodeId, delta);
	// recording.graph = graphStore.graph;
	// if (process.env.NODE_ENV !== "production") return;
	// if (timeout) clearTimeout(timeout);
	// timeout = setTimeout(() => {
	// 	fetch(`/api/metrics/recordings/${recording.id}`, {
	// 		method: "PUT",
	// 		headers: {
	// 			"Content-Type": "application/json",
	// 		},
	// 		body: JSON.stringify({
	// 			id: recording.id,
	// 			start: recording.start,
	// 			domainId: recording.domainId,
	// 			access: Object.fromEntries(recording.access),
	// 			graph: recording.graph,
	// 		}),
	// 	});
	// }, 5000);
}
